import { defineComponent, h } from 'vue';
import { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator, QTooltip } from 'quasar';
import BaseComponent from './BaseButtonMixin.jsx';
import './css/BasicButton.css';

import utils from '../../Shared/utils.jsx';

export default defineComponent({
    name: 'popup-menu-button',
    components: { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator, QTooltip },
    mixins: [BaseComponent],
    data: function () {
        return {
            popupMenuPlacementEval: null,
            popupMenuBackgroundColorEval: null,
            popupMenuFontColorEval: null,
            popupMenuWidthEval: null,
            popupMenuBodyPaddingEval: null,
            isDefaultEval: null,
            isdisabledeval: null,

            menu_data: null,

            modelvalue_watch$: null,
        }
    },
    created() {
        this.isdisabledeval = utils.compile(this, this.controlData.IsDisabled);

        switch (this.controlData.MenuSourceType) {
            case 'Json':
                this.menusourceexpn = utils.compileObject(this, this.controlData.MenuJson);
                this.menu_data = utils.evaluateObject(this.menusourceexpn, this);

                if (!this.modelvalue_watch$)
                    this.modelvalue_watch$ = this.$watch(
                        function () {
                            try {
                                return utils.evaluateObject(this.menusourceexpn, this);
                            }
                            catch (e) {
                                utils.warn('PopupMenuButton MenuJson ' + this.controlData.MenuJson + ' failed to evaluate', e);
                                return null;
                            }
                        },
                        function (val, oldval) {
                            this.Refresh();
                        },
                        {
                            deep: false
                        }
                    );
                break;

            case 'URL':
                this.menuurlexpn = utils.compile(this, this.controlData.MenuURL);
                this.menutemplateexpn = utils.compileObject(this, this.controlData.MenuTemplate);
                break;

            case 'Inline':
            default:
                this.menu_data = this.controlData.Menu;
                break;
        }
    },
    unmounted() {
        if (this.modelvalue_watch$)
            this.modelvalue_watch$();
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        popupMenuPlacement() {
            if (this.popupMenuPlacementEval === null && this.controlData.PopupMenuPlacement)
                this.popupMenuPlacementEval = utils.compile(this, this.controlData.PopupMenuPlacement);
            if (this.popupMenuPlacementEval)
                return utils.evaluate(this.popupMenuPlacementEval, this);
            return 'bottom';
        },
        popupMenuBackgroundColor() {
            if (this.popupMenuBackgroundColorEval === null && this.controlData.PopupMenuBackgroundColor)
                this.popupMenuBackgroundColorEval = utils.compile(this, this.controlData.PopupMenuBackgroundColor);
            if (this.popupMenuBackgroundColorEval)
                return utils.evaluate(this.popupMenuBackgroundColorEval, this);
            return '';
        },
        popupMenuFontColor() {
            if (this.popupMenuFontColorEval === null && this.controlData.PopupMenuFontColor)
                this.popupMenuFontColorEval = utils.compile(this, this.controlData.PopupMenuFontColor);
            if (this.popupMenuFontColorEval)
                return utils.evaluate(this.popupMenuFontColorEval, this);
            return '';
        },
        popupMenuWidth() {
            if (this.popupMenuWidthEval === null && this.controlData.PopupMenuWidth)
                this.popupMenuWidthEval = utils.compile(this, this.controlData.PopupMenuWidth);
            if (this.popupMenuWidthEval)
                return utils.evaluate(this.popupMenuWidthEval, this);
            return '';
        },
        popupMenuBodyPadding() {
            if (this.popupMenuBodyPaddingEval === null && this.controlData.PopupMenuBodyPadding)
                this.popupMenuBodyPaddingEval = utils.compile(this, this.controlData.PopupMenuBodyPadding);
            if (this.popupMenuBodyPaddingEval)
                return utils.evaluate(this.popupMenuBodyPaddingEval, this);
            return '';
        },
        /** When true, menu items use 4px vertical padding (default is 16px). */
        condensed() {
            return !!this.controlData.Condensed;
        },
        isDefault() {
            if (this.isDefaultEval === null && this.controlData.IsDefault)
                this.isDefaultEval = utils.compile(this, this.controlData.IsDefault);
            if (this.isDefaultEval)
                return utils.evaluate(this.isDefaultEval, this);
            return false;
        },
        isdisabled() {
            if (this.isdisabledeval === null && this.controlData.IsDisabled)
                this.isdisabledeval = utils.compile(this, this.controlData.IsDisabled);
            if (this.isdisabledeval)
                return utils.evaluate(this.isdisabledeval, this);
            return false;
        },
        styles() {
            return {
                ...this.sizeStyle,
                overflow: "hidden",
                whiteSpace: "nowrap",
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        }
    },
    methods: {
        preRenderComplete(){
            this.finishRenderHandler(this);
            this.Refresh();
        },
        async Refresh() {
            switch (this.controlData.MenuSourceType) {

                case 'Json':
                    this.menu_data = utils.evaluateObject(this.menusourceexpn, this);
                    break;

                case 'URL':
                    const url = utils.evaluate(this.menuurlexpn, this);
                    const menudata = [];
                    const menu_res = await utils.api.get(url);
                    for (let item of menu_res) {
                        // Save the data for the current element into the sourceData so any references to SourceData() will properly be evaluated
                        this.sourceData = item;

                        // Evaluate the menu item template (which contains all the properties of the menu item including Actions and may have interpolated values via {{ SourceData() }})
                        const menuitem = utils.evaluateObject(this.menutemplateexpn, this);

                        // Copy the source data into the menu item to enabled actions to be executed and still have access to the row via Input.Data
                        menuitem.sourceData = item;

                        menudata.push(menuitem);

                        delete this.sourceData;
                    }
                    this.menu_data = menudata;
                    break;
            }
        },
        async doClick(e, h) {
            e.cancelBubble = true;
            e.stopPropagation();
        },
        menuOpenClose(state) {
            if (this.controlData.OnMenuOpen)
                utils.executeAndCompileAllActions(this.controlData.OnMenuOpen, { State: state }, this);
        },
        menuClick(e, m) {
            if (m.Actions) {
                utils.executeAndCompileAllActions(m.Actions, { Data: m.sourceData }, this);
            }
            else if (this.controlData.Actions)
                utils.executeAndCompileAllActions(this.controlData.Actions, { Data: m.sourceData, Menu: m }, this);
        },
    },
    props: {
    },
    render() {
        if (!this.todisplay)
            return null;

        let content = this.getButtonContent();

        let tooltip = this.renderButtonTooltip();

        let menu;

        if (this.menu_data && this.menu_data.length > 0) {
            const items = [];
            for (let i = 0; i < this.menu_data.length; i++) {
                const m = this.menu_data[i];

                if (m.DisplayExpression && !m.$$displayexpn)
                    m.$$displayexpn = utils.compileExpression(this, m.DisplayExpression);

                if (m.$$displayexpn) {
                    const res = utils.evaluate(m.$$displayexpn, this, false, () => {
                        if (this.todisplayfailed >= 0 && this.todisplayfailed < 10)
                            setTimeout(() => this.todisplayfailed++, 50 * this.todisplayfailed);
                    });
                    if (!res) continue;
                }

                if (m.Separator)
                    items.push(<QSeparator key={`sep-${i}`} />);
                else {
                    if (m.EnabledExpression && !m.$$enabledexpn)
                        m.$$enabledexpn = utils.compileExpression(this, m.EnabledExpression);

                    if (m.Icon && !m.$$iconexpn)
                        m.$$iconexpn = utils.compile(this, m.Icon);

                    if (m.Icon && m.IconColor && !m.$$iconcolorexpn)
                        m.$$iconcolorexpn = utils.compile(this, m.IconColor);

                    if (m.Title && !m.$$titleexpn)
                        m.$$titleexpn = utils.compile(this, m.Title);

                    let menuicon;
                    if (m.$$iconexpn) {
                        let iconcolor;
                        if (m.$$iconcolorexpn)
                            iconcolor = utils.evaluate(m.$$iconcolorexpn, this);
                        const iconName = String(utils.evaluate(m.$$iconexpn, this)).replace(/^\s*mdi\s+/, '').trim();
                        menuicon = <QIcon name={iconName} size="sm" style={iconcolor ? { color: iconcolor } : undefined} />;
                    }

                    const itemDisabled = (m.$$enabledexpn && !utils.evaluate(m.$$enabledexpn, this));
                    const itemTitle = m.$$titleexpn ? String(utils.evaluate(m.$$titleexpn, this)) : '';

                    items.push(
                        <QItem key={i}
                            clickable
                            disable={itemDisabled}
                            onClick={(e) => this.menuClick(e, m)}>
                            {menuicon ? <QItemSection avatar>{menuicon}</QItemSection> : null}
                            <QItemSection>
                                <QItemLabel>{itemTitle}</QItemLabel>
                            </QItemSection>
                        </QItem>
                    );
                }
            }

            const menuListStyle = {
                // Default 0 so hover wash is edge-to-edge (CCDEV-17617).
                padding: this.popupMenuBodyPadding || '0',
                backgroundColor: this.popupMenuBackgroundColor || undefined,
                width: this.popupMenuWidth || undefined,
                color: this.popupMenuFontColor || undefined,
            };

            const menuContent = (
                <QMenu
                    auto-close
                    anchor="bottom left"
                    self="top left"
                    onShow={() => this.menuOpenClose(true)}
                    onHide={() => this.menuOpenClose(false)}
                >
                    <QList
                        dense
                        class={{
                            PopupMenuButtons: true,
                            'text-no-wrap': true,
                            'PopupMenuButtons--condensed': this.condensed,
                        }}
                        style={menuListStyle}
                    >
                        {items}
                    </QList>
                </QMenu>
            );

            const menuTrigger = (
                <QBtn
                    class={[this.buttonClasses, this.sentenceCaseButtonClasses]}
                    style={this.buttonStyles}
                    color={this.color}
                    align={this.align}
                    fab={this.buttonFab}
                    round={this.buttonFab}
                    flat={this.qBtnFlat}
                    outline={this.qBtnOutline}
                    noCaps
                    is-default={this.isDefault}
                    size={this.size}
                    dense={this.density}
                    disable={this.isdisabled === true || this.isdisabled === 'true'}
                >
                    {content}
                    {menuContent}
                    {tooltip}
                </QBtn>
            );
            menu = menuTrigger; // utils.generateTooltip(h, menuTrigger, this.tooltip, this.tooltipLocation);
        }
        else {
            menu = (
                <QBtn
                    class={[this.buttonClasses, this.sentenceCaseButtonClasses]}
                    style={this.buttonStyles}
                    color={this.color}
                    align={this.align}
                    fab={this.buttonFab}
                    round={this.buttonFab}
                    flat={this.qBtnFlat}
                    outline={this.qBtnOutline}
                    noCaps
                    is-default={this.isDefault}
                    size={this.size}
                    dense={this.density}
                    disable={this.isdisabled === true || this.isdisabled === 'true'}
                >
                    {content}
                    {tooltip}
                </QBtn>
            );
            //menu = utils.generateTooltip(h, menu, this.tooltip, this.tooltipLocation);
        }
        return (
            <div
                class={{
                    'c-PopupMenuButton': true,
                    'c-useLiteralCasing': this.useLiteralCasing,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    'q-mr-sm': true,
                }}
                v-show={this.isvisible} style={this.styles}>
                {menu}
            </div>
        );
    }
});